export default {
    action: 'Add mega-trend to an innovation field',
    title: 'Mega-trend',
    subtitle: 'Add to an innovation field',
    submit: 'Done',
    success: 'The mega-trend <strong>"{title}"</strong> was successfully added to an innovation field.'
}
